var _path, _path2, _path3, _g, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFemaleRock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147,
    height: 305,
    fill: "none",
    viewBox: "0 0 147 305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M124.682 195.477L124.2 194.892C118.652 189.165 109.537 189.036 103.842 194.605C98.1466 200.173 98.0303 209.329 103.575 215.055L117.708 229.642L110.188 250.658C107.498 258.17 111.385 266.458 118.868 269.166C126.352 271.874 134.596 267.98 137.284 260.466C144.348 238.07 139.601 213.592 124.682 195.477Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M80.3079 173.061C53.6919 175.063 33.751 198.361 35.7703 225.103L36.5334 239.233C38.5558 265.976 61.7656 286.028 88.3847 284.024C115.001 282.022 134.94 258.724 132.921 231.981L132.156 217.854C130.137 191.109 106.923 171.057 80.3079 173.061Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_178",
    width: 116,
    height: 339,
    x: 6,
    y: -118,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M121.035 211.871L41.2837 220.254L6.69269 -108.858L86.4442 -117.24L121.035 211.871Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_178)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M103.115 184.669L89.4678 -88.4718C87.798 -104.359 58.7288 -114.327 42.9146 -112.665C27.1005 -111.003 8.04655 -95.9765 9.71633 -80.0896L45.8486 190.687C47.5186 206.577 61.6915 218.109 77.5056 216.446C93.3198 214.784 104.785 200.558 103.115 184.669Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3_178",
    width: 122,
    height: 360,
    x: 12,
    y: -119,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M133.877 231.881L49.4188 240.758L12.6074 -109.48L97.0656 -118.356L133.877 231.881Z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3_178)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M99.261 181.668C95.2109 179.926 93.0668 175.388 92.8536 170.969L79.7598 -78.7783C78.09 -94.6654 41.4321 -103.834 25.6179 -102.171C21.284 -101.716 17.2959 -100.292 13.7957 -98.1736C18.3087 -105.585 33.6453 -111.691 42.9144 -112.665C58.7286 -114.327 87.7978 -104.359 89.4676 -88.4719L102.028 171.688C102.167 174.571 103.832 177.147 106.377 178.49C120.639 186.018 134.064 200.012 132.921 231.981C132.921 231.981 133.954 196.589 99.261 181.668Z",
    clipRule: "evenodd"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M84.3039 286.761L84.3008 286.731L79.9501 246.34C79.2734 240.066 73.6637 235.527 67.4193 236.199C61.1849 236.871 56.6758 242.487 57.3336 248.746L57.337 248.778L61.6874 289.166C62.3641 295.44 67.974 299.981 74.218 299.308C80.4526 298.635 84.962 293.022 84.3039 286.761Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M106.797 286.547L106.793 286.517L102.443 246.127C101.766 239.853 96.1564 235.313 89.912 235.985C83.6776 236.657 79.1685 242.273 79.8263 248.532L79.8296 248.564L84.18 288.952C84.8568 295.226 90.4667 299.767 96.7106 299.094C102.945 298.421 107.455 292.808 106.797 286.547Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M128.797 281.547L128.794 281.517L124.443 241.127C123.767 234.853 118.157 230.313 111.912 230.985C105.678 231.657 101.169 237.273 101.827 243.532L101.83 243.564L106.181 283.952C106.857 290.226 112.467 294.767 118.711 294.094C124.946 293.421 129.455 287.808 128.797 281.547Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M77.611 287.416C77.6127 287.406 77.6121 287.427 77.611 287.416C77.611 287.416 79.5101 264.303 79.4359 255.648L80.9556 254.899L84.3012 286.731L84.3044 286.761C84.9625 293.022 80.4549 298.652 74.2185 299.308C71.0689 299.639 70.3305 298.916 69.6366 298.861C74.8003 297.335 76.7099 293.072 77.611 287.416Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M100.104 287.202C100.105 287.192 100.105 287.213 100.104 287.202C100.104 287.202 102.003 264.089 101.929 255.434L103.448 254.685L106.794 286.517L106.797 286.547C107.455 292.808 102.948 298.438 96.7111 299.094C93.5616 299.425 92.8232 298.702 92.1292 298.648C97.293 297.122 99.2026 292.858 100.104 287.202Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M122.104 282.202C122.106 282.192 122.105 282.213 122.104 282.202C122.104 282.202 124.003 259.089 123.929 250.435L125.449 249.685L128.794 281.517L128.798 281.547C129.456 287.808 124.948 293.439 118.712 294.094C115.562 294.425 114.824 293.702 114.13 293.648C119.293 292.122 121.203 287.859 122.104 282.202Z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C3",
    fillRule: "evenodd",
    d: "M64.0776 282.911L64.0745 282.881L59.7241 242.493C59.0473 236.219 53.4374 231.677 47.1932 232.351C40.9588 233.024 36.4495 238.637 37.1075 244.898L37.1107 244.928L41.4613 285.318C42.1381 291.592 47.7477 296.131 53.9919 295.46C60.2266 294.788 64.7357 289.172 64.0776 282.911Z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2BCA7",
    fillRule: "evenodd",
    d: "M59.9561 283.344L59.953 283.314C59.953 283.314 60.2344 247.513 60.9109 253.788L64.0745 282.881L64.0776 282.911C64.7357 289.172 60.2263 294.788 53.9919 295.46C53.2751 295.537 52.5685 295.538 51.874 295.482C57.038 293.956 60.5412 288.91 59.9561 283.344Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB600",
    strokeWidth: 1.701,
    d: "M100.539 161.608C128.541 143.441 17.3261 168.533 31.6948 183.87C33.831 186.151 42.9152 184.918 46.0911 183.796"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB600",
    strokeWidth: 1.701,
    d: "M41.182 166.756C6.30272 171.1 109.201 118.34 109.973 139.173C110.088 142.27 102.301 147.196 99.0564 148.396"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleRock);
export default __webpack_public_path__ + "static/media/female_rock.0985c2f337dbd86faaf770f778cb1568.svg";
export { ForwardRef as ReactComponent };